import { useLang } from "@/context/LanguageContext";
import { TEAM } from "@/data/content";

export default function Team() {
  const { t, lang } = useLang();

  return (
    <section id="team" className="section-y bg-[color:var(--bone)]" data-testid="team-section">
      <div className="container-lux">
        <div className="max-w-2xl">
          <div className="overline" data-testid="team-overline">{t.team.overline}</div>
          <h2
            className="mt-6 font-serif-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.05] tracking-[-0.01em] text-[color:var(--anthracite)]"
            data-testid="team-title"
          >
            {t.team.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {TEAM.map((m) => (
            <div key={m.id} className="group" data-testid={`team-member-${m.id}`}>
              <div className="relative aspect-[3/4] overflow-hidden bg-[color:var(--alabaster)]">
                <img
                  src={m.image}
                  alt={m.name}
                  className="img-cover img-zoom grayscale group-hover:grayscale-0 transition-all duration-700"
                  loading="lazy"
                />
              </div>
              <div className="mt-4">
                <div className="font-serif-display text-[20px] text-[color:var(--anthracite)]">{m.name}</div>
                <div className="mt-1 text-[11px] tracking-[0.22em] uppercase text-[color:var(--copper)]">
                  {m.role[lang] || m.role.en}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
